import { Stack, Typography } from "@mui/material";

const ChangeText = ({ newValue, oldValue, variant = "body2" }) => {
  if (newValue === oldValue) {
    return <Typography variant={variant}>{newValue}</Typography>;
  }
  return (
    <Stack spacing={0.5}>
      {/* New value */}
      <Typography
        variant={variant}
        sx={{
          fontWeight: "bold",
          color: "orange",
        }}
      >
        {newValue}
      </Typography>

      {/* Old value */}
      <Typography
        variant={variant}
        sx={{
          color: "text.secondary", // subtle old value
          textDecoration: "line-through", // optional strike-through
          fontWeight: "bold",
        }}
      >
        {oldValue}
      </Typography>
    </Stack>
  );
};

export default ChangeText;
